import * as React from 'react';
import moment from 'moment';

import { AnimatedButton } from 'components/Map/AnimatedButton';
import styles from './CreateItineraryFromPinsButton.module.css';
import { useTranslation } from 'react-i18next';
import { useMapDisplayContext } from 'components/Map/MapDisplayContext';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';

export const CreateItineraryFromPinsButton = ({
  pinKeys,
  onCloseChat,
}: {
  pinKeys: string[];
  onCloseChat: () => void;
}) => {
  const { t } = useTranslation();
  const { replaceUrlParams } = useMapDisplayContext();
  const itinerary = {
    id: '',
    digital_map_id: '',
    title: '',
    date_itineraries: [
      {
        date: moment().format('YYYY-MM-DD'),
        items: pinKeys.map((pinKey) => ({
          pin_key: pinKey,
          time: '',
          duration: '',
          travel_time: '',
        })),
      },
    ],
  };

  return (
    <AnimatedButton
      className={styles.btn}
      clickedClassName={styles.clicked}
      onClick={() => {
        MapDisplayContextService.setNewItinerary(itinerary);
        replaceUrlParams({ pg: 'ITINERARIES.EDIT', nav: 'map' });
        onCloseChat();
      }}
    >
      {t('Create Itinerary from Items')}
    </AnimatedButton>
  );
};
